module.exports = __webpack_public_path__ + "static/Truck27-5c9f48aa79bff41c28a8a77aabb3b5e1.png";